module.exports = __webpack_public_path__ + "media/images/voice30-721c20ad5813515b3fca0dc501b027df.jpg";